import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { MultiSelectorTreeViewComponent } from './multi-selector-tree-view/multi-selector-tree-view.component';
import { MultiSelectorComponent } from './multi-selector.component';

@NgModule({
  declarations: [
    MultiSelectorTreeViewComponent,
    MultiSelectorComponent 
  ],
  imports: [    
    CommonModule,
    TreeViewModule,
    FormsModule,
    ButtonsModule
  ],
  exports:[
    MultiSelectorComponent
  ],
  entryComponents: [MultiSelectorComponent],
})
export class MultiSelectorModule { }
